<template>
  <section id="timeline" class="section">
    <div class="container">
      Timeline
    </div>
  </section>
</template>

<script>
export default {
  name: 'Timeline',
  components: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
